<h1 mat-dialog-title>Rezerwacje bez pokoi</h1>
<div mat-dialog-actions class="mt-3">
	<button mat-button mat-dialog-close>Anuluj</button>
</div>
<div mat-dialog-content>
	<mat-table #dataTable [dataSource]="data" class="custom-dialog">
		<ng-container matColumnDef="istourName">
			<mat-header-cell *matHeaderCellDef> produkt </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.istourName }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="businessCaseNumber">
			<mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.businessCaseNumber }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="status">
			<mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.status }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="dateFrom">
			<mat-header-cell *matHeaderCellDef> dateFrom </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.dateFrom }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="dateTo">
			<mat-header-cell *matHeaderCellDef> dateTo </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.dateTo }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="code">
			<mat-header-cell *matHeaderCellDef> Pokój </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.code }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="countClient">
			<mat-header-cell *matHeaderCellDef> Il.os </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.countClient }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="rooms">
			<mat-header-cell *matHeaderCellDef> Il.pokoi </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.orderRoom }}/ {{ element.countRoom }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="guarantee">
			<mat-header-cell *matHeaderCellDef> Gwarancje </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.guarantee }} </mat-cell>
		</ng-container>

		<ng-container matColumnDef="viewGuarantee">
			<mat-header-cell *matHeaderCellDef> Gwarancja widoku </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.viewGuarantee }} </mat-cell>
		</ng-container>

		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<button mat-raised-button color="primary" (click)="moveStart(element)">Przenieś</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
	</mat-table>
</div>
